export default __webpack_public_path__ + "static/media/fbIcon.4c733b9b.png";